import * as types from './mutation-types.js'
import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'

const state = {
  ads: [],
  adsTotal: 0,
  audio: {},
  campaigns: [],
  generatedAudioUrl: null
}

const actions = {
  clearAdPreviewAudio ({commit}) {
    commit(types.CLEAR_AUDIO)
    commit(types.CLEAR_AUDIO_ADS)
  },
  clearAdPreviewAds ({commit}) {
    commit(types.CLEAR_AUDIO_ADS)
  },
  async getAdPreviewAds ({commit}, {path, options}) {
    const optionsString = getOptionsString(options)
    const ads = await api.get(path + '&' + optionsString).then(({data}) => data)
    commit(types.SET_AUDIO_ADS, ads)
    return ads
  },
  async getAdPreviewAudio ({commit}, path) {
    const audio = await api.get(path).then(({data}) => data)
    commit(types.SET_AUDIO, audio)
    return audio
  },
  async getAdPreviewCampaigns ({commit}, path) {
    const campaigns = await api.get(path).then(({data}) => data)
    commit(types.SET_AUDIO_CAMPAIGNS, campaigns)
    return campaigns
  },
  async getAdPreviewRandomAds ({commit}, {path, options}) {
    const optionsString = getOptionsString(options)
    return await api.get(path + '&' + optionsString).then(({data}) => data.collection)
  },
  async generateAdPreview ({commit}, {path, payload}) {
    return await api.post(path, payload).then(({data}) => data)
  }
}

const mutations = {
  [types.CLEAR_AUDIO] (state) {
    state.audio = {}
    state.campaigns = []
  },
  [types.CLEAR_AUDIO_ADS] (state) {
    state.ads = []
    state.adsTotal = 0
  },
  [types.SET_AUDIO] (state, audio) {
    state.audio = audio
  },
  [types.SET_AUDIO_ADS] (state, ads) {
    state.ads = ads.collection
    state.adsTotal = ads.count
  },
  [types.SET_AUDIO_CAMPAIGNS] (state, campaigns) {
    state.campaigns = campaigns.collection
  }
}

const getters = {
  adPreviewAds: state => state.ads,
  adPreviewAdsCount: state => state.adsTotal,
  adPreviewAudio: state => state.audio,
  adPreviewCampaigns: state => state.campaigns
}

export default {
  state,
  actions,
  mutations,
  getters
}
